import { useEffect, useState } from 'react'

type CountdownProps = {
  isRunning: boolean
  setIsRunning: (isRunning: boolean) => void

  initial: number
  interval?: number
  step?: number
  children: ((currentValue: number) => React.ReactNode) | React.ReactNode
}

export default function Countdown({
  isRunning,
  setIsRunning,
  initial,
  interval = 1000,
  step = 1,
  children,
}: CountdownProps) {
  if (initial <= 0) throw new Error('invalid initial value')

  const [value, setValue] = useState(0)

  useEffect(() => {
    setValue(initial)
  }, [initial, isRunning])

  useEffect(() => {
    if (!isRunning) return
    if (value <= 0) {
      setIsRunning(false)
      return
    }

    const timer = setTimeout(() => {
      setValue(value - step)
    }, interval)

    return () => clearTimeout(timer)
  }, [interval, isRunning, setIsRunning, step, value])

  return typeof children === 'function' ? children(value) : children
}
